export enum RequestStatus {
  Assigned = "assigned",
  Unassigned = "unassigned",
  Closed = "closed",
}
